import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { Checkbox } from 'antd';
import {
	ApkAssignmentContext,
	IApkAssignmentContext,
} from 'modules/FirmwareAndApp/Apk/ApkAssignment/apkAssignmentState/apkAssignmentContext';
import style from './UnassignedCheckbox.module.scss';

const UnassignedCheckbox: React.FC = () => {
	const { changeIsUnassignedApkStatus, isUnassignedApk } = useContext<IApkAssignmentContext>(ApkAssignmentContext);

	return (
		<Checkbox
			className={style.checkbox}
			onChange={(e) => changeIsUnassignedApkStatus(e.target.checked)}
			checked={isUnassignedApk}
			data-test="UnassignedCheckbox">
			<Text translationNameSpace="listing" translationKey="unassignedTabletAppLabel" asFragment={true} />
		</Checkbox>
	);
};

export default UnassignedCheckbox;
